import React from 'react'

import backofficeRoutes from 'utils/backoffice.routes'
import customerPlatformRoutes from 'utils/customer.routes'

type RuterConfigBase = {
  path: string
  name: string
  icon?: React.FC<React.SVGProps<SVGSVGElement>>
}
export interface RouteConfig extends RuterConfigBase {
  submenu?: RuterConfigBase[]
}

export function getRoutesByAppName(appName: string): RouteConfig[] {
  if (appName === 'backoffice') {
    return backofficeRoutes
  }

  return customerPlatformRoutes
}
